<div class="profile-menu" role="menu" [attr.aria-label]="label('app.layout.menu.ariaLabel')">
  <div class="profile-menu__header">
    <span class="profile-menu__avatar" aria-hidden="true">{{ initials() }}</span>
    <div class="profile-menu__identity">
      <p class="profile-menu__name">{{ firstName() }} {{ lastName() }}</p>
      <p class="profile-menu__company">{{ companyName() }}</p>
    </div>
  </div>

  <div class="profile-menu__content">
    <app-dropdown [items]="languageOptions()" bindLabel="label" bindValue="value" [clearable]="false"
      [searchable]="false" [borderColor]="null" [hoverBackgroundColor]="'var(--safegpt-surface-hover)'"
      [optionHoverBackgroundColor]="'var(--safegpt-surface-hover)'" [showArrowOnHover]="true"
      [ngModel]="selectedLanguage()" (ngModelChange)="onLanguageChanged($event)"
      labelIconPath="icon-menu-globe-regular.svg" labelIconColor="var(--safegpt-text-muted)" />

    <app-dropdown [items]="colorOptions()" bindLabel="label" bindValue="value" [clearable]="false"
      [searchable]="false" [borderColor]="null" [hoverBackgroundColor]="'var(--safegpt-surface-hover)'"
      [optionHoverBackgroundColor]="'var(--safegpt-surface-hover)'" [showArrowOnHover]="true"
      [ngModel]="selectedColor()" (ngModelChange)="onColorChanged($event)"
      labelIconPath="icon-color-switch-regular.svg" labelIconColor="var(--safegpt-text-muted)" />

    <button type="button" class="profile-menu__action" role="menuitem" (click)="openProfileSettings()">
      <app-icon icon="icon-user-clipboard-regular.svg" color="var(--safegpt-text-muted)" [width]="20" [height]="20" />
      <span>{{ label('app.layout.menu.profile') }}</span>
    </button>

    @if (canAccessSettings()) {
      <button type="button" class="profile-menu__action" role="menuitem" (click)="navigateToSettings()">
        <app-icon icon="icon-settings-solid.svg" color="var(--safegpt-text-muted)" [width]="20" [height]="20" />
        <span>{{ label('app.layout.menu.companySettings') }}</span>
      </button>
    }
  </div>

  <div class="profile-menu__footer">
    <button type="button" class="profile-menu__action profile-menu__action--danger" role="menuitem" (click)="logout()">
      <app-icon icon="icon-menu-signout-regular.svg" color="var(--safegpt-danger-text)" [width]="20" [height]="20" />
      <span>{{ label('app.layout.menu.logout') }}</span>
    </button>
  </div>
</div>

@if (isSettingsModalOpen()) {
  <app-profile-settings [open]="isSettingsModalOpen()" (closed)="closeProfileSettings()" />
}
